export enum AppFeature {
  PendingApproval = 'PendingApproval',
  BulkChangeDocumentStatus = 'BulkChangeDocumentStatus',
}
